import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../assetRouteContext';
import { RoutineAllColumn } from './asset-routines-all-column';
import { AssetRoutinesHeader } from './asset-routines-header';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetRoutines = () => {
  const { assetId, issueId } = useParams();
  const navigate = useNavigate();

  if (!assetId) {
    return null;
  }

  const leftColumn = (
    {
      title: 'assets.menu.title',
      mainComponent: (
        <AssetRouteProvider value={{
          basePath: issueId ? `/activities/${issueId}/asset/${assetId}` : `/assets/${assetId}`,
          listPath: issueId ? '/activities' : '/assets',
          isWorkspaceMode: false,
          issueId,
        }}>
          <AssetCard assetId={assetId} />
        </AssetRouteProvider>
      ),
      showBackButton: true,
      headerComponent: (
        <AssetFilters
          assetId={assetId}
        />
      ),
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => navigate(issueId ? '/activities' : '/assets'),
      disableScroll: true
    }
  );

  const rightColumn = (
    {
      title: 'asset.header.buttons.routines',
      mainComponent: (<RoutineAllColumn assetId={assetId} />),
      headerComponent: (
        <AssetRoutinesHeader assetId={assetId} />
      ),
      showBackButton: true,
      backButtonTransition: SlideAction.PREV,
      onBackButtonPress: () => navigate(
        issueId ? `/activities/${issueId}/asset/${assetId}` : `/assets/${assetId}`
      ),
      disableScroll: true
    }
  );

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
